import $ from 'jquery';
import manager from 'app/module46/component-manager.js';

manager.plugin('accessibility', (target) => {
	$('.bloc-text__accordion-checkbox').change(function() {
		if (this.checked) {
			$(this).attr('aria-expanded', 'true');
		} else {
			$(this).attr('aria-expanded', 'false');
		}
	});
});